<template>
  <div class="player">
      <audio ref='playC' >
        <source v-bind:src=play_song type="audio/mpeg">
      </audio> 
      <div class='album' ref='album'></div>
      <div class='control_outline'>
      <div class='control'>
        <div class='songTitle'>{{songTitle}}</div>
        <div class='albumTitle'>{{albumTitle}}</div>
        <div class='process'>
            <!-- <div class="bg-green" > -->
            <input type="range" min="0" max="1000" ref='process'  v-model=process class="slider" @mousedown="CheckMouseDown"  @mouseup="CheckMouseUp" @change="ProcessChangeHandle"/>
            <div  class='processed' v-bind:style="{width: calculatePercentage + '%'}"></div>
          <!-- </div> -->
        </div>
           <div class='timers'>
              <div>{{this.toHHMMSS(currentTime)}} </div>
              <div>{{this.toHHMMSS(maxTime)}} </div>
          </div>
      <div class='btn_list'>
        
        <div  class='btn_ShufflePlayback' ></div>
        <div @click=PlayPreHandle class='btn_Rewind' ></div>
        <div @click=playHandle class='btn_play' v-if="playing==false"></div>
        <div @click=StopHandle class='btn_stop' v-if="playing==true"></div>
        <div @click=PlayNextHandle class='btn_Fast' ></div>
        <div  class='btn_RepeatAll' ></div>

        <!-- <div @click=SwitchModeHandle >ーーーー＞{{mode}}＜ーーー</div> -->
      </div>
      </div>
      <!-- <div class='vv'>
         <span>voice controller</span>
        <span><input type="range" ref="volume" min="0" max="100" v-model=volume></span>
        <span> {{volume}} </span>
      </div> -->
      <div>
    

      </div>
      <!-- <div class='btn_Back'></div> -->
      <!-- <canvas ref="an" width='1000px' height="289px"></canvas> -->
      </div>
  </div>
</template>
<script>

const modeType = ['repeatOne','repeatAll'];
const status = ['play','pause'];
export default {
  name: 'Player',
  props: {
    msg: String
  },
  data: function () {
    return {
      albums:
        [{
          albumTitle:'Quincas Moreira',
          cover_url:'',
          no:1,
          songTitle:'Metamorphosis',
          file_url:'https://www.youtube.com/audiolibrary_download?vid=86dd9259b534cc4d'       
          },
          {
            albumTitle:'Quincas Moreira',
            cover_url:'',
            no:2,
            songTitle:'Mariposa',
            file_url:'https://www.youtube.com/audiolibrary_download?vid=3d9ea88f85a351f8'       
          },
          {
            albumTitle:'Quincas Moreira',
            cover_url:'',
            no:2,
            songTitle:'Spy Suite',
            file_url:'https://www.youtube.com/audiolibrary_download?vid=f560266c20699a04'       
          }


          
        ],
      currentSongIdx:0,
      songTitle:null,
      albumTitle:null,
      play_song:null,
      playing: false,
      volume:50,
      process:0,
      mode:'repeatall',
      Shuffle: false,
      currentTime:0,
      maxTime:0,
      mouseDownCheck:false,
      canvas:null,
      canvasProp:{},
      ctx:null,
      analyser:null,
      audioSrc:null,
      frequencyData:null

    }
  },
  methods:{
    playHandle() {
      this.$refs.playC.play();
      this.playing = true;
      console.log('play event')
    },
    StopHandle() {
      this.$refs.playC.pause();
      this.playing = false;
      console.log('stop event')
    },
    PlayNextHandle() {
      if (this.currentSongIdx == this.albums.length - 1){
        this.currentSongIdx = 0;
      }else{
         this.currentSongIdx++;
      }      
      var music = this.albums[this.currentSongIdx];
      this.loadMusic(music);
    },
    PlayPreHandle() {
      if (this.currentSongIdx == 0){
        this.currentSongIdx = this.albums.length - 1
      }else{
         this.currentSongIdx--;
      }      
      var music = this.albums[this.currentSongIdx];
      this.loadMusic(music);
    },
    VolumeChangeHandle(e) {
      this.$refs.playC.volume = e.target.value / 100
    },
    ProcessChangeHandle(e) {
      var audioObj = this.$refs.playC
      var currentStatus = audioObj.paused;
      audioObj.currentTime = e.target.value / 1000 * this.maxTime
    },
    SwitchModeHandle() {
      let mode;
      switch (this.mode) {
        case 'repeatOne':
          mode = 'repeatAll'
          break
        case 'repeatAll':
          mode = 'random'
          break
        case 'random':
          mode = 'repeatOne'
          break
        default:
          mode = 'repeatOne'
          break
      }
      this.mode = mode;
    },
    toHHMMSS:function (sec) {
        var sec_num = parseInt(sec, 10); // don't forget the second param
        var hours   = Math.floor(sec_num / 3600);
        var minutes = Math.floor((sec_num - (hours * 3600)) / 60);
        var seconds = sec_num - (hours * 3600) - (minutes * 60);

        if (hours   < 10) {hours   = "0"+hours;}
        if (minutes < 10) {minutes = "0"+minutes;}
        if (seconds < 10) {seconds = "0"+seconds;}
        return hours+':'+minutes+':'+seconds;
    },
    getCurrentTime: function() {
      if (this.mouseDownCheck == true) return
      this.currentTime = this.$refs.playC.currentTime
      this.process = this.currentTime / this.maxTime * 1000
    },
    CheckMouseDown: function(){
        this.mouseDownCheck = true
    },
    CheckMouseUp: function(){
      this.mouseDownCheck = false
    },
    renderFrame:  function() {
      var array = new Uint8Array(this.analyser.frequencyBinCount);
      this.analyser.getByteFrequencyData(array);
      var step = Math.round(array.length / this.canvasProp.meterNum); //sample limited data from the total array
      this.ctx.clearRect(0, 0, this.canvasProp.cwidth, this.canvasProp.cheight);
      this.ctx.fillStyle = this.canvasProp.bg_gradient;
      this.ctx.fillRect(0, 0, this.canvasProp.cwidth, this.canvasProp.cheight);

      this.ctx.beginPath();
      this.ctx.moveTo(0, this.canvasProp.cheight / 2);
      this.ctx.lineTo(this.canvasProp.cwidth, this.canvasProp.cheight / 2);
      this.ctx.strokeStyle = this.canvasProp.lineColor;
      this.ctx.lineWidth = 0.5;
      this.ctx.stroke();
      for (var i = 0; i < this.canvasProp.meterNum; i++) {
          var value = array[i * step];
          if (this.canvasProp.capYPositionArray.length < Math.round(Math.abs(this.canvasProp.meterNum))) {
              this.canvasProp.capYPositionArray.push(value);
          };
          this.ctx.fillStyle = this.canvasProp.lineColor;
          this.ctx.fillRect(this.canvasProp.cwidth - i * 6 - this.canvasProp.meterWidth, (this.canvasProp.cheight - value) / 2, this.canvasProp.meterWidth, value); 
      }
      requestAnimationFrame(this.renderFrame);
    },
    loadMusic(music){
      var _this = this
      var audioObj = _this.$refs.playC
      this.play_song = music.file_url;
      _this.albumTitle = music.albumTitle;
      _this.songTitle = music.songTitle;
      this.process = 0;
      audioObj.load();
      audioObj.oncanplay = function(){
        _this.maxTime = audioObj.duration;
        if (_this.playing) audioObj.play();
      }
    },
    songendHandle(){
      var audioObj = this.$refs.playC
      if (this.mode == 'repeatOne'){
        audioObj.currentTime = 0
      }else if (this.mode == 'repeatall'){
        this.PlayNextHandle();
        // if (this.Shuffle == true){

        // }
      }
      // this.StopHandle();
      // console.log('sond end');
    }
  },
  computed: {
    calculatePercentage: function(){
      return this.currentTime / this.maxTime * 100;
    }
    // getCurrentTime: function() {
    //   console.log(this.$refs.playC);
    //   if (this.$refs.playC !== undefined){
    //       this.currentTime = this.$refs.playC.currentTime
    //       return this.$refs.playC.currentTime;
    //   }
    // }
  },
  watch: {
    process: function(){
      this.currentTime = this.$refs.process.value / 1000 * this.maxTime
    },
    volume: function(){
      this.$refs.playC.volume = this.$refs.volume.value / 100
    }
  },
  mounted(){
    var _this = this
    var audioObj = this.$refs.playC
    var audioSource = this.$refs.audioSource

    var music = _this.albums[0];
    audioObj.ontimeupdate = this.getCurrentTime
    audioObj.onended = this.songendHandle
    for (var i = 0; i < 100; i++){
      console.log( Math.floor(( Math.random() * (this.albums.length) )))
    }
    this.loadMusic(music);
    // var ctx = new AudioContext();
    // this.analyser = ctx.createAnalyser();
    // this.audioSrc = ctx.createMediaElementSource(audioObj);
    // this.audioSrc.connect(this.analyser);
    // this.analyser.connect(ctx.destination);

    // this.frequencyData = new Uint8Array(this.analyser.frequencyBinCount);

    // this.canvas = this.$refs.an
    // this.canvasProp.cwidth = this.canvas.width
    // this.canvasProp.cheight = this.canvas.height
    // this.canvasProp.meterWidth = 1,
    // this.canvasProp.gap = 1,
    // this.canvasProp.lineColor = '#fff',
    // this.canvasProp.meterNum = 100, //count of the meters
    // this.canvasProp.capYPositionArray = []; ////store the vertical position of hte caps for the preivous frame
    // //bg color
    //   this.ctx = this.canvas.getContext('2d');
    //   var bg_gradient = this.ctx.createLinearGradient(0, 0, 0, 300);
    //   bg_gradient.addColorStop(0, "#AFC5FF");
    //   bg_gradient.addColorStop(1, "#FACEFF");
    //   this.canvasProp.bg_gradient = bg_gradient
    //   this.renderFrame();
  }
}


</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
.vv > *{
  margin:0px 20px;
}


.player {
  position: relative;
  width:375px;
  height:100vh;
  min-height: 812px;
  background: #000;
  background-image: url('/flower.png');
  background-size: cover;
  align-content: center;
  padding-top: 76px;
}

.album{
  width:327px;
  height:447px;
  border: #FFF 10px;
  border-style: solid;
  margin: 0 auto;
  box-shadow: 0px 0px 3px 1px rgba(0, 0, 0, 0.2);
}

.control_outline{
  position: absolute;

  width: 375px;
  height: 276px;
  background-image:linear-gradient(rgba(255,255,255,0) ,rgba(255,255,255,1) 20%);
  bottom: 0px;
  
}

.control{
  position: relative;
  padding-top:42px;
  width: 327px;
  height: 182px;
  margin: 0px auto;
  

}

.songTitle{
  font-size: 22px;
  font-style: 'Merriweather Sans';
  font-weight: bold;
  padding:0px;
}
.albumTitle{
  font-size: 16px;
  font-style: 'Merriweather Sans';
  padding-bottom:16px;
}
.process {
  position: relative;
  outline: none;
  width:100%;
  background-color: rgba(180, 180, 180, 0.8);
  height:2px;
  display: flex;
  justify-self: center; 
  margin:  auto;
  z-index: 2;
}

.slider{
  appearance: none;
  outline: none;
  position: absolute;
  width:100%;
  margin: 0;
  top: -5px;
  cursor: pointer;
  z-index: 1;
  background: transparent;
}
.slider::-webkit-slider-thumb {

  -webkit-appearance: none; /* Override default look */
  appearance: none;
  width: 6px; /* Set a specific slider handle width */
  height: 6px; /* Slider handle height */
  background: #000; /* Green background */
  cursor: pointer; /* Cursor on hover */
  border-radius: 3px;
}

.slider::-moz-range-thumb {
  width: 6px; /* Set a specific slider handle width */
  height: 6px; /* Slider handle height */
  background: #000; /* Green background */
  cursor: pointer; /* Cursor on hover */
  border-radius: 3px;
}

.processed {

  width:100%;
  height:2px;
  border: 2px;
  background: rgb(0, 0, 0);
  border-radius: 2px;
  margin: 0px;
  z-index: 1;
  pointer-events: none;
}

.timers{
  position: relative;
  top:14px;
  font-size: 10px;
  width:100%;
  height: 13px;
  font-style: 'Merriweather Sans';
  color: #AEAEAE;
  display: flex;
  justify-content: space-between;
  }

  .timers > *{
      color: #AEAEAE;
  }
  
.bg-green{
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  width:100%;
  height:5px;
  border: 1px;
  background: rgb(38, 235, 159);
  text-align: left;
  padding: 5px 10px;
}
.bg-green > input{
  position: absolute;
  left: 50%;
  top:50%;
  transform: translate(-50%,-50%);
  margin: 0px;
}

.btn_Back {
  width:44px;
  height: 44px;
  background-repeat:no-repeat;
  fill:black;
  background-image: url("/svg/btn_Back.svg");

}

.btn_play {
  width: 70px;
  height: 70px;
  background-repeat:no-repeat;
  fill:black;
  background-image: url("/svg/btn_Play.svg");

}

.btn_stop {
  width: 70px;
  height: 70px;
  background-repeat:no-repeat;
  fill:black;
  background-image: url("/svg/btn_pause.svg");
}


.btn_Fast {
  width: 50px;
  height: 50px;
  background-repeat:no-repeat;
  fill:black;
  background-image: url("/svg/btn_Fast.svg");
}

.btn_ShufflePlayback{
  width: 50px;
  height: 50px;
  background-repeat:no-repeat;
  background-image: url("/svg/btn_ShufflePlayback.svg");
}

.btn_RepeatAll{
  width: 50px;
  height: 50px;
  background-repeat:no-repeat;
  background-image: url("/svg/btn_RepeatAll.svg");
}

.btn_RepeatOne{
  width: 50px;
  height: 50px;
  background-repeat:no-repeat;
  background-image: url("/svg/btn_RepeatOne.svg");
}
.btn_Rewind {
  width: 50px;
  height: 50px;
  background-repeat:no-repeat;
  fill:black;
  background-image: url("/svg/btn_Rewind.svg");
}

.btn_list{
  margin-top: 10px;
  width: 100%;
  height: 70px;
  display: flex;
  justify-content: space-between;
  justify-items: center;
  align-items: center;
}

.btn_list > *{
    align-items: center;

}

</style>
